'use strict';
angular.module('cakeapp')

.directive('focusInput', function() {
    return {
        link: function(scope, element) {
            element[0].focus();
        }
    };
});
